import React, { Component, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
  getAllStylesAction,
  updateThemeAction,
  updateBackgroundAction,
  updateTextColorAction,
  updateButtonAction,
  updateImageLinkAction,
  updateShowFooterAction,
} from 'store/modules/styles';
import { toggleTutorialModal } from 'store/modules/modals';

import { reloadIframe } from 'helpers/reloadIframe';

import PreviewMode from 'components/PreviewMode';
import CounterGroup from 'components/CounterGroup';
import ThemeDetails from './ThemeDetails';
import AlertBottomMessage from 'components/AlertBottomMessage';

import ViewUpgrade from 'components/ViewUpgrade';
import BackgroundStyle from './BackgroundStyle';
import TextColorStyles from './TextColorStyles';
import ButtonStyles from './ButtonStyles';
import ImageLinkStyles from './ImageLinkStyles';
import linkCopy from 'images/link-copy.svg';
import linkGo from 'images/link-go.svg';
import videoSvg from 'images/video-solid.svg';

const DashboardNavigation = ({ id, toggle }) => {
  return (
    <div className="nav-tabs">
      <div className="nav-tabs__inner">
        <NavLink to={`/domain/page/${id}/content`} className="nav-tabs__link">
          Content
        </NavLink>
        <NavLink to={`/domain/page/${id}/styles`} className="nav-tabs__link">
          Styles
        </NavLink>
        <NavLink to={`/domain/page/${id}/analytics`} className="nav-tabs__link">
          Analytics
        </NavLink>
        <div
          className="std-text blue pointer p-l-150 tutorial-help__link"
          onClick={toggle}>
          <span className="icon-outline">
            <img src={videoSvg} alt="acc" />
          </span>
          <span className="link-text">Watch tutorial</span>
        </div>
      </div>
    </div>
  );
};

class Styles extends Component {
  state = {
    spinner: false,
  };

  componentDidMount() {
    const { getAllStylesAction, match } = this.props;
    const id = match.params.id;
    getAllStylesAction(id);
  }

  acceptChangeTheme = async body => {
    const { updateThemeAction, match } = this.props;
    const id = match.params.id;
    const response = await updateThemeAction(id, body);

    if (response.status === 200) {
      reloadIframe();
    } else {
      console.error('acceptChangeTheme error', response);
    }
  };

  toggleSpinner = () => {
    this.setState({
      spinner: !this.state.spinner,
    });
  };

  toggleModal = () => {
    const { toggleTutorialModal } = this.props;
    toggleTutorialModal();
  };

  acceptBackgroundStyles = async data => {
    this.toggleSpinner();
    const { updateBackgroundAction, match } = this.props;
    const body = {
      background: data,
    };
    const id = match.params.id;
    const response = await updateBackgroundAction(id, body);

    if (response.status === 200) {
      reloadIframe();
    } else {
      console.error('acceptBackgroundStyles error', response);
    }
    this.toggleSpinner();
  };

  acceptTextColor = async data => {
    const { updateTextColorAction, match } = this.props;
    const body = {
      text_color: data,
    };
    const id = match.params.id;
    const response = await updateTextColorAction(id, body);

    if (response.status === 200) {
      reloadIframe();
    } else {
      console.error('acceptTextColor error', response);
    }
  };

  acceptButtonStyles = async data => {
    const { updateButtonAction, match } = this.props;
    const body = {
      button: data,
    };
    const id = match.params.id;
    const response = await updateButtonAction(id, body);

    if (response.status === 200) {
      reloadIframe();
    } else {
      console.error('acceptButtonStyles error', response);
    }
  };

  acceptImageLinkStyles = async data => {
    const { updateImageLinkAction, match } = this.props;
    const body = {
      image_link: data,
    };
    const id = match.params.id;
    const response = await updateImageLinkAction(id, body);

    if (response.status === 200) {
      reloadIframe();
    } else {
      console.error('acceptImageLinkStyles error', response);
    }
  };

  acceptShowFooter = async value => {
    const { updateShowFooterAction, match } = this.props;
    let body = {};
    if (value) {
      body = {
        footer_state: 'enabled',
      };
    } else {
      body = {
        footer_state: 'disabled',
      };
    }
    const id = match.params.id;
    const response = await updateShowFooterAction(id, body);
    if (response.status === 200) {
      reloadIframe();
    } else {
      console.error('acceptShowFooter error', response);
    }
  };

  render() {
    const { subscribed } = this.props.details;
    const { styles, account } = this.props;
    const { spinner, openModal } = this.state;
    const customTheme = styles.themes_info.current_theme_used;
    let themeValue = customTheme ? customTheme : 'custom';
    let showFooterValue =
      styles.style.footer_current_state === 'footer_disabled' ? false : true;
    return (
      <Fragment>
        <AlertBottomMessage styles />
        <DashboardNavigation id={account.id} toggle={this.toggleModal} />
        <ThemeDetails
          accepThemeDetails={this.acceptChangeTheme}
          options={styles.themes_info.themes}
          optionDefaultValue={themeValue}
          acceptShowFooter={this.acceptShowFooter}
          showFooterValue={showFooterValue}
          subscribed={subscribed}
        />
        {!customTheme && subscribed ? (
          <Fragment>
            <BackgroundStyle
              backgroundStyleValues={styles.style.background}
              acceptBackgroundStyles={this.acceptBackgroundStyles}
              backgroundImages={styles.background_images}
              thumbImages={styles.thumb_images}
              thumbImage={styles.style}
              isImageLoading={spinner}
              styles={styles}
            />
            <TextColorStyles
              defaultTextColorValues={styles.style.text_color}
              acceptTextColor={this.acceptTextColor}
            />
            <ButtonStyles
              styles={styles}
              defaultButtonValues={styles.style.button}
              acceptButtonStyles={this.acceptButtonStyles}
            />
            <ImageLinkStyles
              defaultImageLinkValues={styles.style.image_link}
              acceptImageLinkStyles={this.acceptImageLinkStyles}
            />
            {/*<ViewUpgrade
              text="Upgrade to create Image links"
              textBtn="View Plans"
            />*/}
          </Fragment>
        ) : null}
      </Fragment>
    );
  }
}

function mapStateProps(state) {
  return {
    styles: state.styles.style,
    details: state.details.user,
    account: state.content.account,
  };
}

const mapDispatchToProps = {
  getAllStylesAction,
  updateThemeAction,
  updateBackgroundAction,
  updateTextColorAction,
  updateButtonAction,
  updateImageLinkAction,
  updateShowFooterAction,
  toggleTutorialModal,
};
export default connect(
  mapStateProps,
  mapDispatchToProps,
)(withRouter(Styles));



// WEBPACK FOOTER //
// ./src/scenes/Styles/Styles.js